import { Autocomplete, Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import React from 'react';

const CustomerInformationCard = ({
    searchBy,
    SearchBy,
    allowedSearchBy = ['referenceNo', 'consumerId'],
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
    defaultCircle,
    circleList,
    setDefaultCircle,
    defaultDivision,
    divisionList,
    setDefaultDivision,
    subDivision,
    subDivisionList,
    setSubDivision,
    showSubmitErrors = false,
    hideCategory = false,
    hideTariff = false,
    showTelco = false,
}) => {

    // Check if only one search option is allowed
    const isSingleSearchOption = allowedSearchBy.length === 1;

    return (
        <Grid container className='container' spacing={2}>

            {/* Search By Section */}
            {!isSingleSearchOption && (
                <Grid item xs={2.5}>
                    <Typography className="fieldLabel"> Search By</Typography>
                    <FormControl className="form-control">
                        <RadioGroup
                            row
                            name="iv_search_by"
                            value={searchBy}
                            onChange={SearchBy}
                        >
                            {allowedSearchBy.includes('referenceNo') && (
                                <FormControlLabel
                                    value="referenceNo"
                                    control={<Radio />}
                                    label="Reference No."
                                />
                            )}

                            {allowedSearchBy.includes('consumerId') && (
                                <FormControlLabel
                                    value="consumerId"
                                    control={<Radio />}
                                    label="Customer ID."
                                />
                            )}
                        </RadioGroup>
                    </FormControl>
                </Grid>
            )}

            {/* Customer ID Field */}
            {searchBy === 'consumerId' && (
                <Grid item xs={1.5} sx={{ paddingRight: '20px' }}>
                    <Typography className='fieldLabel'>Customer ID.</Typography>
                    <TextField
                        type='text'
                        name="iv_consumer_id"
                        autoComplete='off'
                        value={values.iv_consumer_id}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{ maxLength: 10 }}
                        id="iv_consumer_id"
                        className='textInputField'
                    />
                    <Box className='from-Error'>
                        {errors.iv_consumer_id && touched.iv_consumer_id ? (errors.iv_consumer_id) : null}
                    </Box>
                </Grid>
            )}

            {/* Reference No Field */}
            {searchBy === 'referenceNo' && (
                <Grid item xs={1.5} sx={{ paddingRight: '20px' }}>
                    <Typography className='fieldLabel'>Reference No.</Typography>
                    <TextField
                        type='text'
                        name="iv_reference_number"
                        autoComplete='off'
                        value={values.iv_reference_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{ maxLength: 14 }}
                        id="iv_reference_number"
                        className='textInputField'
                    />
                    <Box className='from-Error'>
                        {errors.iv_reference_number && touched.iv_reference_number ? (errors.iv_reference_number) : null}
                    </Box>
                </Grid>
            )}

            {/* Name */}
            <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Name</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_applicant_name"
                    value={values.iv_applicant_name}
                    autoComplete='off'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    id="iv_applicant_name"
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_applicant_name && touched.iv_applicant_name ? (errors.iv_applicant_name) : null}
                </Box>
            </Grid>

            {/* Father's / Husband's Name */}
            <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Father's / Husband's Name</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_father_name"
                    value={values.iv_father_name}
                    autoComplete='off'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    id="iv_father_name"
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_father_name && touched.iv_father_name ? (errors.iv_father_name) : null}
                </Box>
            </Grid>

            {/* NIC / CNIC / NICOP */}
            <Grid item xs={2}>
                <Typography className='fieldLabel'>NIC. / CNIC. / NICOP.</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_applicant_cnic"
                    disabled
                    value={values.iv_applicant_cnic}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="iv_applicant_cnic"
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_applicant_cnic && touched.iv_applicant_cnic ? (errors.iv_applicant_cnic) : null}
                </Box>
            </Grid>

            {/* Telco */}
            {showTelco && (
            <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>
                  Telco <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                    select
                    required
                    name="iv_telco"
                    value={values.iv_telco ?? ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                    size='small'
                    SelectProps={{ native: true }}
                >
                    <option value={0}>Select</option>
                    <option value={1}>Jazz</option>
                    <option value={1}>Warid</option>
                    <option value={2}>Ufone</option>
                    <option value={2}>Onic</option>
                    <option value={3}>Telenor</option>
                    <option value={4}>Zong</option>
                    <option value={5}>SCom</option>
                </TextField>
                <Box className='from-Error'>
                    {showSubmitErrors && errors.iv_telco
                        ? errors.iv_telco
                        : null}
                </Box>
            </Grid>
            )}

            {/* Phone No */}
           <Grid item xs={1} sx={{ paddingRight: '20px' }}>
    <Typography className='fieldLabel'>
      Phone No. <span style={{ color: 'red' }}>*</span>
    </Typography>
    <TextField
      required
      type='text'
      name="iv_applicant_phone_no"
      autoComplete='off'
      value={values.iv_applicant_phone_no}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{ maxLength: 11 }}
      id="iv_applicant_phone_no"
      className='textInputField'
    />
    {/* Keep your custom red box if you want both styles */}
    <Box className='from-Error'>
      {showSubmitErrors && errors.iv_applicant_phone_no 
        ? errors.iv_applicant_phone_no 
        : null}
    </Box>
  </Grid>

            {/* Category */}
            {!hideCategory && (
            <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Category</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_connection_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_connection_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_connection_type && touched.iv_connection_type ? (errors.iv_connection_type) : null}
                </Box>
            </Grid>
            )}

            {/* Phase */}
            <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Phase</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_phase"
                    disabled
                    autoComplete='off'
                    value={values.iv_phase}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_phase && touched.iv_phase ? (errors.iv_phase) : null}
                </Box>
            </Grid>

            {/* Meter Type */}
            <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Meter Type</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_meter_type"
                    disabled
                    autoComplete='off'
                    value={values.iv_meter_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                    sx={{
                        backgroundColor: values.iv_meter_type !== 'Smart' ? 'blue' : ''
                    }}
                />
                <Box className='from-Error'>
                    {errors.iv_meter_type && touched.iv_meter_type ? (errors.iv_meter_type) : null}
                </Box>
            </Grid>

            {/* Tariff */}
            {!hideTariff && (
            <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Tariff</Typography>
                <TextField
                    required
                    type='text'
                    name="iv_tariff_description"
                    disabled
                    autoComplete='off'
                    value={values.iv_tariff_description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField1'
                />
                <Box className='from-Error'>
                    {errors.iv_tariff_description && touched.iv_tariff_description ? (errors.iv_tariff_description) : null}
                </Box>
            </Grid>
            )}

            {/* Circle */}
            <Grid item xs={1.25} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Circle</Typography>
                <Autocomplete
                    id="iv_circle"
                    name="iv_circle"
                    disabled
                    value={defaultCircle || null}
                    options={circleList}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                    )}
                    onChange={(event, value) => {
                        if (value) {
                            setDefaultCircle(value);
                            values.iv_circle = value.code;
                        }
                    }}
                />
                <Box className='from-Error'>
                    {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                </Box>
            </Grid>

            {/* Division */}
            <Grid item xs={1.25} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Division</Typography>
                <Autocomplete
                    id="iv_division"
                    name="iv_division"
                    disabled
                    value={defaultDivision || null}
                    options={divisionList}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                    )}
                    onChange={(event, value) => {
                        if (value) {
                            setDefaultDivision(value);
                            values.iv_division = value.code;
                        }
                    }}
                />
                <Box className='from-Error'>
                    {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                </Box>
            </Grid>

            {/* Sub Division */}
            <Grid item xs={1.25} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Sub Division</Typography>
                <Autocomplete
                    id="iv_sub_divison"
                    name="iv_sub_divison"
                    disabled
                    value={subDivision || null}
                    options={subDivisionList}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                    )}
                    onChange={(event, value) => {
                        if (value) {
                            setSubDivision(value);
                            values.iv_sub_divison = value.code;
                        }
                    }}
                />
                <Box className='from-Error'>
                    {errors.iv_sub_divison && touched.iv_sub_divison ? (errors.iv_sub_divison) : null}
                </Box>
            </Grid>

            {/* Address */}
            <Grid item xs={3.25}>
                <Typography className='fieldLabel'>Address</Typography>
                <TextField
                    name='iv_address'
                    required
                    type='text'
                    value={values.iv_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                    className='textInputFieldAddressing'
                />
            </Grid>

        </Grid>
    );
};

export default CustomerInformationCard;
